define(function (require) {
    require("jquery");
    var ajax = require("ajax-promise");
    require("bootstrap");
    require("amcharts.serial");
    require("amcharts.xy");
    require("amcharts.fr");
    require("amcharts.it");
    var moment = require("moment");
    require("modernizr");
    require("moment.fr");
    var FinancialItem = require("FinancialItem");
    require("amcharts.plugins.export");
    var i18n = require("i18n");
    var errorHandler = require("error-handler");
    var _Drop = require("drop");
	require("carousel");
	var currencyHelper = require("currencyHelper");
    

    $(function () {
        $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
        $('a[href=""]').click(function (e) { e.preventDefault(); });

		$('.lstCurrencyData').on('change', function (e)
		{
			var sCurrencyData = $(e.currentTarget).val();
			if (sCurrencyData)
			{
				reloadCurrency(sCurrencyData);
			}

		});


        initCharts();
        initFavs();

		$.each($(".navigate-content"), function (index, elt) {
			$(elt).navigateCarousel({ autoScroll: true, autoScrollDelay: 6, scrolIcon: 1 });
    });
	});


	function reloadCurrency(sNewCurrency)
	{
		var sNewUrl = currencyHelper.appendCurrencyToUrl(window.location.href, sNewCurrency);
		window.location.assign(sNewUrl);
	}


    $(function () {
        $(".btnExportComparaison").click(function (e) {
            e.preventDefault();

            var isComparaisonV2 = $("#isComparaisonV2").val();
            if (isComparaisonV2 === "true") {
                doCompareV2();
            }
            else {
                doCompareV1();
            }
        });

        function doCompareV2() {
			var listProduits = [];

            var financialItem = FinancialItem.fromString($("#produit-identifier").val());
			if (financialItem != null) listProduits.push(financialItem);

            var financialItemCat = FinancialItem.fromString($("#produit-identifier-cat").val());
			if (financialItemCat != null) listProduits.push(financialItemCat);

            var financialItemBench = FinancialItem.fromString($("#produit-identifier-bench").val());
			if (financialItemBench != null) listProduits.push(financialItemBench);

            ajax.post("/Comparaison/GetUrlComparaisonWithProduits", {
				listProduits: listProduits
            }).then(function (data) {
                if ($("#sCustomerName").val() === "AXAROPP") {
                    require(['/Areas/Partenaire/AxaROPP/Static/AxaRoppEvent.js'], function (AxaRoppEvent) {
                        AxaRoppEvent.insert("Click", "comparer-supports");
                        window.location = data.sUrl;
                        return false;
                    });
                }
                else {
                    window.location = data.sUrl;
                    return false;
                }
            }).catch(function (ex) {
                errorHandler.displayError(ex);
            });
        }

        function doCompareV1() {
            var produitId = $("#id-produit");

            var url = "/compare/comparaison_fonds.aspx?id_a=" + produitId.val();

            var catId = $("#id-cat");
            if (catId.val() != '0')
                url += "&id_cat=" + catId.val();

            var benchId = $("#id-bench");
            if (benchId.val() != '0')
                url += "&id_bench=" + benchId.val();

            window.location = url;
            return false;
        }

        $(".simulerEpargne").click(function (e) {
            e.preventDefault();
            window.location = '/moncompte/backtest/comparaison_portBackTest.aspx?bSimEpargne=1&ID_A=' + $("#id-produit").val();
        });

      
        // pup manager
        pubManager();
    });


   
    // Loads all the static graphs (already pre-loaded into the html page)
    function initCharts() {
        var $scope = $('#panelChartHistorique');
		$scope.find('a[data-toggle="pill"]').on('show.bs.tab show.bs.tab.data-api', function (e) {
            var $target = $(e.target);

            $("#sDtRangeStart").attr("value", moment($target.data('dtstarthisto'), "DDMMYYYY").format("DD-MM-YYYY"));
            $("#sDtRangeEnd").attr("value", moment($(".qtjs-dtendhisto").text(), "DDMMYYYY").format("DD-MM-YYYY"));

            $scope.find('.qtjs-dtstarthisto').text(moment($target.data('dtstarthisto'), "DDMMYYYY").format('DD/MM/YYYY'));
        });

        $('.qtjs-chart-histo').each(function (item) {
            var $this = $(this);
            var chartConfig = $this.data("chart-serie");

            if (chartConfig !== null && chartConfig !== "") {

                //Sinon la date sur l'axe abcisse est coupée à droite
                //chartConfig.marginRight = 20;

                //Export
                var hasExportCharts = $("#hasExportCharts").val();
                if (hasExportCharts === "true") {
                    chartConfig.export = {
                        enabled: true,
                        fileName: $("#produitsNom").val()
                    }
                }

                AmCharts.makeChart($this[0], chartConfig);
            }

        });

        $('.qtjs-chart-fvscat').each(function (item) {
            var $this = $(this);
            var serie = $this.data("chart-serie");

            if (serie !== null && serie !== "") {
                serie.graphs[0].urlField = "url3"; // clickable scatter
                AmCharts.makeChart($this[0], serie);
            }
        });
    }

    function initFavs() {

        $('input[value="new"]', '#formFavoris').attr('checked', true);

        $("#addToFavorites").click(function () {
            if (!$(this).hasClass("disabled"))
                $("#favoriteModal").modal("show");
        });

        $("#validerFavoris").click(function () {
            var isDisabled = $(this).hasClass('disabled');
            if (!isDisabled) {
                $("#favoriteModal").modal("hide");
                var selected = $('input[name=optradio]:checked', '#formFavoris').val()
                if (selected === "new" && $("#nameListeFavorites").val() != null) {
                    var nameListe = $("#nameListeFavorites").val();
                    validateFavoris(0, nameListe, true);
                    notify("", "Le favoris " + nameListe + " a été créé avec " + $("#produitsNom").val().split("_")[1], 'success');
                }
                else if (selected === "add") {
                    var idListe = $("#selectFavorites option:selected").val();
                    validateFavoris(idListe, "", false);
                    notify("",$("#produitsNom").val().split("_")[1] + " a été ajouté à la liste " + $("#selectFavorites option:selected").text(), 'success');
                }
                else {
                    notify("", "Veuillez renseigner une liste de favoris", 'danger');
                }

                checkElt($('input[value="new"]', '#formFavoris'));
                if (!hasClassDisable($("#validerFavoris")))
                    $("#validerFavoris").addClass("disabled");
            }
        });

        $("#selectFavorites").change(function () {
            checkElt($('input[value="add"]', '#formFavoris'));
            $("#validerFavoris").removeClass("disabled");
        });

        $('#nameListeFavorites').on('input', function () {
            checkElt($('input[value="new"]', '#formFavoris'));
            if ($(this).val() != null && $(this).val() != "") {
                if (hasClassDisable($("#validerFavoris")))
                    $("#validerFavoris").removeClass("disabled");
            }                
            else {
                if (!hasClassDisable($("#validerFavoris")))
                    $("#validerFavoris").addClass("disabled");
            }                  
        });

        $('input[name=optradio]').change(function () {
            if ( !hasClassDisable($("#validerFavoris")) )
                $("#validerFavoris").addClass("disabled");
        });

        setListFavorites();
    }

    function hasClassDisable(elt) {
        var isDisabled = $(elt).hasClass('disabled');
        if (isDisabled)
            return true;
        return false;
    }

    function checkElt(elt) {
        $('input[name=optradio]:checked', '#formFavoris').attr("checked", false);
        $(elt).attr("checked", true);
    }

    function validateFavoris(idListe, nameListe, newOrAdd) {
        console.log(idListe + " " + nameListe + " " + newOrAdd);
        ajax.post("/Produit/ValidateFavorite", {
            ID_produit: $("#id-produit").val(),
            listName: nameListe,
            listValue: idListe,
            NewOrAdd: newOrAdd
        })
            .then(function () {
                setListFavorites();
            });
    }

    function setListFavorites() {
        $("#selectFavorites").empty();
        return ajax.post("/Produit/GetListFavorites", {})
            .then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    $("#selectFavorites").append($('<option>', {
                        text: data[i].Item1,
                        value: data[i].Item2
                    }))
                }
            });
    }


    function simulate() {
        var financialItem = FinancialItem.fromString($("#produit-identifier").val());

        ajax.post("/Comparaison/GetUrlComparaisonWithProduits", {
            listProduits: [financialItem]
        }).then(function (data) {

            var tabUrl = data.sUrl.split("/");
            var compareID = tabUrl[tabUrl.length - 1];
            var sParamComparaison = "?ID_Comparaison=" + compareID;
            window.location = "/moncompte/backtest/comparaison_portBackTest.aspx" + sParamComparaison;
            return false;
        }).catch(function (ex) {
            errorHandler.displayError(ex);
        });
    }

    function notify(title, msg, type, icon) {
        if (icon == null)
            icon = 'glyphicon-ok';

        // type ex: info, danger, warning, success 
        $.notify({
            icon: 'glyphicon ' + icon,
            title: title,
            message: msg
        },
            {
                type: type
            });
    }


    /**
     *  Ads manager
     */

    /*function pubManager() {

        var pubCampagne = window.sessionStorage.getItem('data-campagne');

        if (pubCampagne == null || pubCampagne != $(".pup-remove").attr("data-campagne")){
            $(".pub-ciblee-container").css({ "display": "block" });
            var $linkHref = $("a.pub-ciblee", ".pub-ciblee-container").attr("href");            

            if ($linkHref != null){
                var pudIDParam = $linkHref.split("&")[0].split("?")[1];
                var imgSRC = $("#pxlBlancValue").val().split("?")[0] + "?" + pudIDParam + "&" + $("#pxlBlancValue").val().split("&")[1];
                $("#pxlBlanc").html('<img id="ciblee-pxlBlanc728x90-displayCounter" src="' + imgSRC + '" style="width: 1px; height: 1px;" />');
            }
            else {
                $("#pxlBlanc").html('<img id="ciblee-pxlBlanc728x90-displayCounter" src="' + $("#pxlBlancValue").val() + '" style="width: 1px; height: 1px;" />');
            }            
        }
        else {
            $(".ciblee-pxlBlanc728x90").empty();
        }

        $(".pup-remove").on("click", function () {
            $(".pub-ciblee-container").css({ "display": "none" });
            $("#pxlBlanc").empty();
            window.sessionStorage.setItem('data-campagne', $(this).attr("data-campagne") );
        });

    }*/

	/******************************************************************************************************/
	/*____________________________________________________[ Pub ]_________________________________________*/
    function pubManager() {

        var pubCampagne = window.sessionStorage.getItem('data-campagne');

        if (pubCampagne == null || pubCampagne != $(".pup-remove").attr("data-campagne")) {
            pubCampagne = $(".pup-remove").attr("data-campagne");
            $(".pub-ciblee-container").css({ "display": "block" });
            $(".pxlBlanc[data-campagne='" + pubCampagne + "']").html('<img class="ciblee-pxlBlanc728x90-displayCounter" src="' + $(".pxlBlancValue[data-campagne='" + pubCampagne +"']").val() + '" style="width: 0px; height: 0px;" />');
        }
        else {
            $(".ciblee-pxlBlanc728x90").empty();
        }

        $(".pup-remove").on("click", function () {
            $(".pub-ciblee-container").css({ "display": "none" });
            $(".pxlBlanc[data-campagne='" + $(".pup-remove").attr("data-campagne") + "']").empty();
            window.sessionStorage.setItem('data-campagne', $(this).attr("data-campagne"));
        });

    }

	$(function () {

		var g = {};

		$(".pub-scroll").each(function (index) {
			
			_initLexiqueScroll($(this));
			
		});	
		
		function _initLexiqueScroll($eltContainer) {
			
			var $Pub = $(".follow-scroll", $eltContainer);
			var margeBottom = 0;

			var chartContainer = $("#chartHistoriqueBase");
			if (chartContainer.length > 0) {
				margeBottom = 30; // prise en compte de la hauteur de la legende du graph ajouté dynamiquement.
			}

			if ($Pub.length > 0 ) {

				if (!g.initialPositionY)
					g.initialPositionY = $Pub.offset().top;

				if (!g.ParentTop)
					g.ParentTop = $Pub.parent().offset().top; 
				
				//On met l'element en position relative pour pouvoir le deplacer
				$Pub.css('position', 'relative');

				if (!g.pubExpandedHeight)
					g.pubExpandedHeight = $eltContainer.height();

				$(window).on('scroll', function (event) {
					followOnScroll(g.pubExpandedHeight + margeBottom, $Pub);
				}).scroll();
			}
		}

		function followOnScroll(hauteurpubScroll, $Pub) {
			var scrollTop = $(window).scrollTop();
			var currentScroll = scrollTop < g.initialPositionY ? g.initialPositionY - scrollTop : 0;
			$Pub.stop(false, false).animate({
				top: currentScroll > 0 ? scrollTop - (g.ParentTop - $(window).height()) - hauteurpubScroll : currentScroll
			}, 500);
		}
	});

	/*_____________________________________________________________________________________________________*/
	/******************************************************************************************************/
    //function initPopupAlerts() {

    //    var drop = new _Drop({
    //        target: $(".drop-alerts").get(0),
    //        classes: 'drop-theme-arrows-bounce',
    //        position: 'bottom left',
    //        constrainToWindow: true,
    //        constrainToScrollParent: false,
    //        openOn: 'click',
    //        content: $(".popupLinksAlerts").get(0)
    //    });

    //    return drop;
    //}





});
